export default "__VITE_ASSET__D8w61nU7__"